// extracted by mini-css-extract-plugin
export default {"import_info_card":"import_import_info_card__j0MSl","card_content_label":"import_card_content_label__9A8jj"};